// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cp-tab li a {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  padding: 0 20px !important;\n}\n.cp-tab li a:hover {\n  color: #063CAA !important;\n}\n.cp-beforetab {\n  margin-top: 0px !important;\n}\n.cp-realgrid {\n  width: 100%;\n  height: 483px;\n}\n.cp-realgrid--hide {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
